import React, { createRef, useEffect } from "react";
import Diagram, {
  Command,
  ContextMenu,
  ContextToolbox,
  Group,
  HistoryToolbar,
  MainToolbar,
  PropertiesPanel,
  Tab,
  Toolbox,
  ViewToolbar,
} from "devextreme-react/diagram";
import { Icon } from "../../../../components/icon";
import "../diagram/diagram.scss";
import { Button } from "../../../../modules/button";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { Box } from "../../../../components/box";
import "whatwg-fetch";
import Swal from "sweetalert2";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { CreateNotification } from "../../../../components/notifier";

const DiagramPage = (props: any) => {
  const { id } = useRouteMatch().params as any;
  const history = useHistory();
  const diagramRef: any = createRef<any>();
  const pageCommands: string[] = ["pageSize", "pageOrientation", "pageColor"];
  const menuCommands: string[] = ["bringToFront", "sendToBack", "lock", "unlock"];
  const location: any = useLocation();
  const data = location?.state?.data;
  const jsonData = data?.diagramJson ? JSON.parse(data?.diagramJson) : {};

  const onCustomCommand = (e: any) => {
    if (e.name === "clear") {
      Swal.fire({
        title: "Cảnh báo",
        text: "Anh/chị có chắc chắn muốn xóa biểu đồ này? Hành động này không thể hoàn tác.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
      }).then((result: any) => {
        if (result.isConfirmed) {
          e.component.import("");
        }
      });
    }
  };

  const onSelectionChanged = (e: any) => {
    // Displays the "showGrid" and "snapToGrid" commands when a user selects no items
    if (e.items.length === 0) e.component.option("contextMenu.commands", ["showGrid", "snapToGrid"]);
    // Displays the "fontName", "fontSize", and "selectShapes" commands when a user selects a shape
    else if (e.items[0].itemType === "shape")
      e.component.option("contextMenu.commands", [
        "fontName",
        "fontSize",
        { name: "selectShapes", text: "Select All Shapes" },
      ]);
    // Displays the "connectorLineStart", "connectorLineEnd", and "selectConnectors" commands when a user selects a connector
    else
      e.component.option("contextMenu.commands", [
        "connectorLineStart",
        "connectorLineEnd",
        { name: "selectConnectors", text: "Select All Connectors" },
      ]);
  };

  const handleConfirm = async () => {
    const diagram = diagramRef.current.instance;
    const diagramJson = diagram.export();
    try {
      await DocumentContentService.update(id, { diagramJson: JSON.stringify(diagramJson) });
      CreateNotification({ title: "Lưu thành công", body: "Lưu biểu đồ thành công", icon: "/icons/success.png" });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (jsonData) {
      const diagram = diagramRef.current.instance;
      diagram.import(jsonData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonData]);

  // useEffect(() => {
  //   const diagram = diagramRef;
  //   fetch('src/pages/document/components/diagram/diagram-flow.json')
  //     .then((response) => response.json())
  //     .then((json) => {
  //       diagram.import(JSON.stringify(json));
  //     })
  //     .catch(() => {
  //       throw new Error('Data Loading Error');
  //     });
  // },[])

  return (
    <>
      <div className="diagram__container">
        <Box
          title={
            <div className="d-flex flex-row">
              <div title={"Trở về trang soạn thảo"} className="btnBack" onClick={() => history.goBack()}>
                <Icon.ArrowLeft />
              </div>
              <p className="mt-2">Trình vẽ biểu đồ</p>
            </div>
          }
          titleRight={
            <div className="pr-3">
              <Button type="submit" buttonType="success" label="Xác nhận" onClick={() => handleConfirm()} />
              <Button type="button" label="Huỷ" buttonType="danger" className="ml10" onClick={() => history.goBack()} />
            </div>
          }
          className="form__diagram-container"
        >
          <Diagram
            id="diagram"
            ref={diagramRef}
            onCustomCommand={onCustomCommand}
            onSelectionChanged={onSelectionChanged}
          >
            <ContextMenu enabled={true} commands={menuCommands} />
            <ContextToolbox enabled={true} category="flowchart" shapeIconsPerRow={5} width={200} />
            <PropertiesPanel visibility="visible">
              <Tab>
                <Group title="Trang" commands={pageCommands} />
              </Tab>
            </PropertiesPanel>
            <HistoryToolbar visible={false} />
            <ViewToolbar visible={true} />
            <MainToolbar visible={true}>
              <Command name="undo" text="Hoàn tác" />
              <Command name="redo" text="Làm lại" />
              <Command name="separator" />
              <Command name="fontName" />
              <Command name="fontSize" />
              <Command name="separator" />
              <Command name="bold" />
              <Command name="italic" />
              <Command name="underline" />
              <Command name="separator" />
              <Command name="fontColor" text="Màu chữ" />
              <Command name="lineColor" text="Màu nét vẽ" />
              <Command name="fillColor" text="Tô màu" />
              <Command name="separator" />
              <Command name="clear" icon="clearsquare" text="Xóa biểu đồ" />
            </MainToolbar>
            <Toolbox visibility="visible" showSearch={false} shapeIconsPerRow={4} width={230}>
              <Group category="general" title="General" />
              <Group category="flowchart" title="Flowchart" expanded={true} />
              <Group category="orgChart" title="Organizational Chart" expanded={true} />
              <Group category="containers" title="Containers" expanded={true} />
            </Toolbox>
          </Diagram>
        </Box>
      </div>
    </>
  );
};

export default DiagramPage;
